<template>
    <div
        class="unit-stack"
        :class="{
            [typeAsClass]: type,
            'reveal-facedown': revealFacedown,
            'selected': stackIsSelected,
        }"
    >
        <unit-coin
            v-for="(unit, index) of units"
            :key="`unit-${index}`"
            :unit="unit"
            :showActions="shouldShowActions(unit, index)"
            :index="index"
            :onCommandCallback="onCommandCallback"
			:multiple-targets="units.length >= 2 && longBoatAtPosition"
        />
		<div
			v-if="units.length >= 2 && longBoatAtPosition"
			@click="selectLongboat"
			class="mini-coin-wrapper"
		 >
			<unit-image
				:unitType="UNIT_TYPE_LONGBOAT"
				classes="mini-coin"
			/>
		</div>
    </div>
</template>

<script>
import {
    UNIT_STATE_DEPLOYED,
    UNIT_STATE_DISCARDED_FACEUP,
    UNIT_STATE_RECRUITED,
	UNIT_TYPE_BISHOP,
	UNIT_TYPE_KNIGHT,
	UNIT_TYPE_LONGBOAT,
} from '../Unit/Unit-types';

export default {
    name: 'UnitStack',
    props: [
        'actions',
        'units',
        'revealFacedown',
        'onCommandCallback',
        'type',
    ],
    data() {
        return {
            UNIT_STATE_DEPLOYED,
			['UNIT_TYPE_LONGBOAT']: UNIT_TYPE_LONGBOAT,
        };
    },
    computed: {
        actionsState() {
            return this.$store.state.actionsState;
        },
		currentPlayer() {
            return this.$store.getters.player;
        },
        stackIsSelected() {
            const { selectedUnitId, friendlyUnitId } = this.actionsState;

            return this.units.filter(u =>
                u.type && [selectedUnitId, friendlyUnitId].includes(u.id),
            ).length;
        },
        typeAsClass() {
            return this.type ? this.type.replace(/_/g, '-') : '';
        },
		showFlipLongboatIcon() {
			return this.longBoatAtPosition?.id && this.actionsState.selectedUnitActions.find(
				action => action.opponentUnitId === this.longBoatAtPosition.id,
			);
		},
		isFriendlyLongboat() {
			const longboat = this.longBoatAtPosition;

			if (!longboat) return false;

			const { playerId } = longboat;
			const players = this.$store.state.gameState.players;
			const player = players.find(p => p.id === playerId);

			return player?.teamId === this.currentPlayer?.teamId;
		},
		longBoatAtPosition() {
			return this.units.find(u =>
				u.position &&
				u.type === UNIT_TYPE_LONGBOAT,
			);
		},
    },
    methods: {
		selectLongboat() {
			const longboat = this.longBoatAtPosition;

			if (!longboat) return;

			const { id: longboatId } = longboat;

			if (this.isFriendlyLongboat) {
				this.$store.dispatch('selectFriendlyUnitId', longboatId);
			}
		},
        shouldShowActions(unit, index) {
            const actions = this.actions || [];

            if (unit.state === UNIT_STATE_DEPLOYED) {
				if (this.longBoatAtPosition && this.units.length >= 2) {
					const isLongboat = unit.type === UNIT_TYPE_LONGBOAT;
					const attackRestrictedTypes = [UNIT_TYPE_BISHOP, UNIT_TYPE_KNIGHT];

					if (attackRestrictedTypes.includes(this.units[this.units.length - 1].type)) {
						return (isLongboat && unit.position) || (unit.position && this.currentPlayer?.id === unit.playerId);
					}

					return !isLongboat && unit.position;
				}

                return unit.position;
            }

            if (unit.state === UNIT_STATE_DISCARDED_FACEUP) {
                return true;
            }

            if (unit.state === UNIT_STATE_RECRUITED && actions.find(action => action.unitId === unit.id)) {
                return true;
            }

            return index === 0;
        },
    },
};
</script>

<style lang="scss">
    .unit-stack {
        position: relative;

        &.top-of-bag {

            &:hover {

                .unit-coin {

                    &:not(:first-of-type) {
                        $leftIncrement: 4;
                        $leftPercentage: 0 + $leftIncrement;
                        $topIncrement: 20;
                        $topPercentage: 0 - $topIncrement;

                        @for $i from 2 through 10 {
                            &:nth-of-type(#{$i}) {
                                left: #{$leftPercentage + '%'};
                                top: #{$topPercentage + '%'};
                                $leftPercentage: $leftPercentage + $leftIncrement;
                                $topPercentage: $topPercentage - $topIncrement;

                                .unit-image {
                                    box-shadow: -2px 2px 1px -1px rgba(0,0,0,0.2);
                                }
                            }
                        }
                    }
                }
            }
        }

        &.reveal-facedown {

            &:hover {

                .discarded-facedown {

                     &:not(:first-of-type) {
                        $leftIncrement: 4;
                        $leftPercentage: 0 + $leftIncrement;
                        $topIncrement: 20;
                        $topPercentage: 0 - $topIncrement;

                        @for $i from 2 through 10 {
                            &:nth-of-type(#{$i}) {
                                left: #{$leftPercentage + '%'};
                                top: #{$topPercentage + '%'};
                                $leftPercentage: $leftPercentage + $leftIncrement;
                                $topPercentage: $topPercentage - $topIncrement;

                                .unit-image {
                                    box-shadow: -2px 2px 1px -1px rgba(0,0,0,0.2);
                                }
                            }
                        }
                    }

                    .unit-image {
                        display: none;
                    }

                    .facedown-unit-image {
                        display: block;
                    }
                }
            }
        }

		.mini-coin-wrapper {
			position: relative;
			cursor: pointer;
			top: -5%;
			left: -5%;
			position: absolute;
			width: 45%;
			height: 45%;
			z-index: 100;

			.flip-icon {
				position: absolute;
				left: 50%;
				top: 50%;
				height: 60%;
				width: 60%;
				transform: translate(-50%, -50%);
			}

			.mini-coin {
				height: 100%;
				width: 100%;
			}
		}

        .unit-coin {

            &:not(:first-of-type) {
                $leftIncrement: 4;
                $leftPercentage: 0 + $leftIncrement;
                $topIncrement: 8.5;
                $topPercentage: 0 - $topIncrement;
                height: auto;
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;

                @for $i from 2 through 10 {
                    &:nth-of-type(#{$i}) {
                        left: #{$leftPercentage + '%'};
                        top: #{$topPercentage + '%'};
                        $leftPercentage: $leftPercentage + $leftIncrement;
                        $topPercentage: $topPercentage - $topIncrement;

                        .unit-image {
                            box-shadow: -2px 2px 1px -1px rgba(0,0,0,0.2);
                        }
                    }
                }

                &.infiltrator {

                    @for $i from 2 through 10 {
                        &:nth-of-type(#{$i}) {
                            .unit-image {
                                box-shadow: -1px 2.5px 1px -1px rgba(125, 125, 125, .4);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
